import { createContext } from 'react';

export const CreationContactContext = createContext(null);
